export default __webpack_public_path__ + "static/kasa_3-535c2544c83a77a6f609a268e5a4ecf3.png";